























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ImplIntraOperasiChecklist extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, any>;
  @Prop({ default: false }) readonly disabled!: boolean;

  localValue: Record<string, any> = {};

  checkItems = [
    { key: "atur_posisi_anatomi", label: "Mengatur posisi sesuai anatomi" },
    { key: "pasang_ground_couter", label: "Memasang ground couter dengan benar" },
    { key: "pemberian_anestesi", label: "Melakukan pemberian anestesi sesuai prosedur" },
    { key: "cuci_tangan_bedah_steril", label: "Melakukan cuci tangan bedah, memakai baju steril, sarung tangan steril dengan teknik steril" },
    { key: "teknik_aseptik_antiseptik", label: "Melakukan teknik aseptik dan antiseptik pada area pembedahan dengan alkohol 70% dan povidone iodine 10%" },
    { key: "drapping", label: "Melakukan drapping sesuai prosedur" },
    { key: "hitung_instrumen_kasa_jarum", label: "Menghitung instrumen, kasa, jarum (pra dan pasca harus sama)" },
    { key: "pastikan_esu_suction", label: "Memastikan ESU dan suction berfungsi" },
    { key: "time_out", label: "Melakukan Time Out" },
    { key: "batasi_personel_max_10", label: "Membatasi personel di kamar operasi maksimal 10 orang" },
    { key: "siapkan_pa_kultur", label: "Menyiapkan pemeriksaan PA atau kultur jaringan" },
    { key: "monitor_intake_output_cairan", label: "Memonitor intake dan output cairan" },
    { key: "monitor_vital_sign", label: "Memonitor vital sign" },
    { key: "sign_out", label: "Melakukan Sign Out" }
  ];

  mounted() {
    this.localValue = { ...this.value };
  }

  @Watch("value", { deep: true })
  onValueChange(val) {
    this.localValue = { ...val };
  }

  emitChange() {
    this.$emit("input", { ...this.localValue });
  }
}
